module.exports = __webpack_public_path__ + "img/earth-light-small.12fd711a.svg";